import { useCallback } from "react";
import { useSnackbar } from "@/hooks/useSnackbar";
import { SCRIBE_COPY_TRANSCRIPT_LABELS } from "./constants";
import { formatTranscriptForCopy } from "./transcript-turns";
import { ScribeTranscriptLine } from "./types";

export interface UseCopyTranscript {
  copyTranscript: () => Promise<void>;
  canCopy: boolean;
}

export const useCopyTranscript = (
  lines: ScribeTranscriptLine[]
): UseCopyTranscript => {
  const showSnackbar = useSnackbar();

  const copyTranscript = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(formatTranscriptForCopy(lines));
      showSnackbar({
        type: "success",
        message: SCRIBE_COPY_TRANSCRIPT_LABELS.SUCCESS,
      });
    } catch {
      showSnackbar({
        type: "error",
        message: SCRIBE_COPY_TRANSCRIPT_LABELS.FAILURE,
      });
    }
  }, [lines, showSnackbar]);

  return { copyTranscript, canCopy: lines.length > 0 };
};
